<template>
    <div class="col-sm-12 col-xs-12" v-if="!isLoading">
        <div class="alert alert-success" v-if="this.isSaved">
            <strong>{{ 'Your settings has been saved'|trans }}</strong>
        </div>

        <div v-if="!isSaving">
            <h4>{{'Settings'|trans}}</h4>
            <hr>
            <label>{{"Range of action"|trans}}</label>
            <p>{{'Maximum acceptable distance between two clients'|trans}}</p>

            <div class="form-group">
                <select class="form-control" v-model="preferences.ratioSelected">
                    <option v-for="km in kmRatioData" :value="km.value">
                        {{ km.text }}
                    </option>
                </select>
            </div>

<!--            <div class="form-group">-->
<!--                <ToggleButton-->
<!--                        v-model="preferences.loopAccepted"-->
<!--                        v-bind:value="preferences.loopAccepted"-->
<!--                        v-bind:sync="true"-->
<!--                        v-bind:color="{checked: '#a9d5f7', unchecked: '#cfcfcf'}"-->
<!--                        v-bind:width="60"-->
<!--                        v-bind:height="34"-->
<!--                >-->
<!--                </ToggleButton>&nbsp;-->
<!--                <label><h5>{{ 'Accepts road loops'|trans }}</h5></label>-->
<!--            </div>-->

            <input type="button" :value="'Save my settings'|trans" class="btn btn-primary" @click="submitPreferences">
        </div>
        <div v-else>
            <Spinner :title="'Saving settings'|trans"></Spinner>
        </div>
    </div>
    <div v-else>
        <Spinner :title="'Loading settings'|trans"></Spinner>
    </div>
</template>

<script>
	import Spinner from "../Spinner";

	export default {
		components: {Spinner},
		data() {
			return {
				isLoading :false,
				isSaving: false,
				isSaved: false,
				kmRatioData: [],
				preferences: {
					loopAccepted: false,
					ratioSelected: 30,
				}
			}
		}, created() {
			this.kmRatio();
			this.getPreferences();
		},
		methods: {
			kmRatio() {
				for (let i = 1; i < 21; i++) {
					let value = i * 5;
					this.kmRatioData.push({text: value + 'km', value: value});
				}
			},
			async submitPreferences() {
				this.isSaving = true;
				await this.$api.worker.savePreferences(this.preferences);
				this.isSaving = false;
				this.isSaved = true;

			},
			async getPreferences() {
				this.isLoading = true;
				this.preferences = await this.$api.worker.getPreferences();
				this.isLoading = false;
			}
		}
	}

</script>


<style lang="scss" scoped>

</style>
